const isEnabled = () => String(process.env.REACT_APP_ENABLE_PERFORMANCE_MONITORING || '').toLowerCase() === 'true';

const perfState = {
  routeRequests: new Map(),
  routeStarts: new Map(),
  installed: false,
};

const routeKey = () => {
  if (typeof window === 'undefined') return 'server';
  return `${window.location.pathname}${window.location.search}`;
};

const writeEvent = (payload) => {
  if (!isEnabled() || typeof window === 'undefined') return;
  const existing = JSON.parse(sessionStorage.getItem('agency_os_perf_events') || '[]');
  existing.push({ ts: Date.now(), ...payload });
  sessionStorage.setItem('agency_os_perf_events', JSON.stringify(existing.slice(-500)));
};

export const markRouteStart = (name) => {
  if (!isEnabled() || typeof performance === 'undefined') return;
  perfState.routeStarts.set(name, performance.now());
  perfState.routeRequests.set(name, []);
  writeEvent({ type: 'route-start', route: name });
};

export const markRouteReady = (name, extra = {}) => {
  if (!isEnabled() || typeof performance === 'undefined') return;
  const start = perfState.routeStarts.get(name);
  const requests = perfState.routeRequests.get(name) || [];
  if (start != null) {
    const loadMs = performance.now() - start;
    const duplicates = requests.reduce((acc, url) => {
      acc[url] = (acc[url] || 0) + 1;
      return acc;
    }, {});
    writeEvent({
      type: 'route-ready',
      route: name,
      load_ms: Number(loadMs.toFixed(1)),
      request_count: requests.length,
      duplicate_request_count: Object.values(duplicates).filter((n) => n > 1).length,
      duplicates,
      ...extra,
    });
  }
};

export const installPerformanceFetchObserver = () => {
  if (!isEnabled() || perfState.installed || typeof window === 'undefined' || typeof window.fetch !== 'function') return;
  perfState.installed = true;
  const original = window.fetch.bind(window);
  window.fetch = async (...args) => {
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url;
    const route = routeKey();
    const bucket = perfState.routeRequests.get(route);
    if (bucket && url && url.includes('/api/')) {
      bucket.push(url);
    }
    return original(...args);
  };
};

export const getCollectedPerformanceEvents = () => {
  if (typeof window === 'undefined') return [];
  try {
    return JSON.parse(sessionStorage.getItem('agency_os_perf_events') || '[]');
  } catch {
    return [];
  }
};
